import * as React from 'react';

var Context = React.createContext({ context: null });
var useUitkContext = function () { return React.useContext(Context); };
// Wrapping component and render prop so class components can access useUitkContext
var UitkContextWrapper = function (_a) {
    var children = _a.children;
    var _b = useUitkContext(), context = _b.context, data = _b.data;
    return children(context, data);
};
var UitkContextProvider = function (_a) {
    var children = _a.children, config = _a.config;
    return (React.createElement(Context.Provider, { value: config }, children));
};
UitkContextProvider.displayName = 'UitkContextProvider';

export { UitkContextProvider, UitkContextWrapper, useUitkContext };
